import { menusConstants } from '@constants/menus';
import { DEFAULT_PAGE_SIZE } from '@constants/pagination';
import { menusService } from '@services';

export const menusActions = {
    getAll,
};

function getAll(page = 0, pageSize = DEFAULT_PAGE_SIZE, { silent = false } = {}) {
    return dispatch => {
        if (!silent) dispatch(request());

        menusService.getAll(page, pageSize).then(
            menus => dispatch(success(menus)),
            error => dispatch(failure(error.toString())),
        );
    };

    function request() {
        return { type: menusConstants.MENUS_REQUEST };
    }
    function success(menus) {
        return { type: menusConstants.MENUS_SUCCESS, menus };
    }
    function failure(error) {
        return { type: menusConstants.MENUS_ERROR, error };
    }
}
